<div *ngIf="totals as claimTotals" class="border rounded-xl px-4 py-3" data-testid="claim-totals">
  <p class="text-sm font-semibold text-gray-900 mb-2">
    Claim Totals <span class="text-gray-400 font-normal">· {{ claimTotals.currency }}</span>
  </p>

  <dl class="flex flex-col gap-1 text-sm">
    <div class="flex justify-between">
      <dt class="text-gray-500">Requested</dt>
      <dd data-testid="totals-requested">{{ formatAmount(claimTotals.requestedTotal) }}</dd>
    </div>
    <div class="flex justify-between">
      <dt class="text-gray-500">Authorized gross</dt>
      <dd data-testid="totals-authorized">{{ formatAmount(claimTotals.authorizedGross) }}</dd>
    </div>
    <div class="flex justify-between">
      <dt class="text-gray-500">Tax</dt>
      <dd data-testid="totals-tax">{{ formatAmount(claimTotals.tax) }}</dd>
    </div>
    <div class="flex justify-between">
      <dt class="text-gray-500">Deductible</dt>
      <dd data-testid="totals-deductible">-{{ formatAmount(claimTotals.deductible) }}</dd>
    </div>
    <div class="flex justify-between border-t pt-1 mt-1 font-semibold text-gray-900">
      <dt>Net payable</dt>
      <dd data-testid="totals-net">{{ formatAmount(claimTotals.netPayable) }}</dd>
    </div>
  </dl>
</div>
